<script>
  import { format, parse } from 'date-fns'
  import {
    authComputed,
    settingMethods,
    settingsComputed,
    businessesMethods,
  } from '@state/helpers'

  export default {
    computed: {
      ...authComputed,
      ...settingsComputed,
      isoStandardFormat(){
        return "yyyy-MM-dd'T'HH:mm:ss"
      },
      sqlRegex(){
        return /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
      }
    },
    mounted() {
      if (!this.dateLocale) {
        this.getBusiness(this.currentUser.business.id)
          .then(({ data }) => {
            this.setDateLocale(data.address.country.code)
          })
      }
    },
    methods: {
      ...businessesMethods,
      ...settingMethods,
      transformSQLTimestamp(sqlStringTimestamp){
        if (sqlStringTimestamp.match(this.sqlRegex) !== null){
          sqlStringTimestamp = sqlStringTimestamp.replace(' ', 'T')
        }
        try{
          const date = parse(sqlStringTimestamp, this.isoStandardFormat, new Date());
          if (isNaN(date)){
            throw new Error(String.concat('Parsing failed for non-iso dateTime: \'', sqlStringTimestamp, '\''));
          }
        }catch(err){
          return null
        }
        return sqlStringTimestamp
      },
      getFormatByLocale() {

        const formats = {
          "ZA": "yyyy/MM/dd",
          "ET": "d/M/yyyy",
          "AE": "dd/MM/yyyy",
          "BH": "dd/MM/yyyy",
          "DZ": "dd-MM-yyyy",
          "EG": "dd/MM/yyyy",
          "IQ": "dd/MM/yyyy",
          "JO": "dd/MM/yyyy",
          "KW": "dd/MM/yyyy",
          "LB": "dd/MM/yyyy",
          "LY": "dd/MM/yyyy",
          "MA": "dd-MM-yyyy",
          "OM": "dd/MM/yyyy",
          "QA": "dd/MM/yyyy",
          "SA": "dd/MM/yy",
          "TN": "dd-MM-yyyy",
          "YE": "dd/MM/yyyy",
          "AZ": "dd.MM.yyyy",
          "BY": "dd.MM.yyyy",
          "BG": "dd.M.yyyy",
          "BD": "dd-MM-yy",
          "CN": "yyyy/M/d",
          "FR": "dd/MM/yyyy",
          "BA": "d.M.yyyy",
          "ES": "dd/MM/yyyy",
          "CZ": "d.M.yyyy",
          "GB": "dd/MM/yyyy",
          "DK": "dd-MM-yyyy",
          "AT": "dd.MM.yyyy",
          "CH": "dd.MM.yyyy",
          "DE": "dd.MM.yyyy",
          "LI": "dd.MM.yyyy",
          "LU": "dd.MM.yyyy",
          "MV": "dd/MM/yy",
          "GR": "d/M/yyyy",
          "029": "MM/dd/yyyy",
          "AU": "dd/MM/yyyy",
          "BZ": "dd/MM/yyyy",
          "CA": "dd/MM/yyyy",
          "IE": "dd/MM/yyyy",
          "JM": "dd/MM/yyyy",
          "MY": "d/M/yyyy",
          "NZ": "d/MM/yyyy",
          "PH": "M/d/yyyy",
          "TT": "dd/MM/yyyy",
          "US": "M/d/yyyy",
          "ZW": "M/d/yyyy",
          "AR": "dd/MM/yyyy",
          "BO": "dd/MM/yyyy",
          "CL": "dd-MM-yyyy",
          "CO": "dd/MM/yyyy",
          "CR": "dd/MM/yyyy",
          "DO": "dd/MM/yyyy",
          "EC": "dd/MM/yyyy",
          "GT": "dd/MM/yyyy",
          "HN": "dd/MM/yyyy",
          "MX": "dd/MM/yyyy",
          "NI": "dd/MM/yyyy",
          "PA": "MM/dd/yyyy",
          "PE": "dd/MM/yyyy",
          "PR": "dd/MM/yyyy",
          "PY": "dd/MM/yyyy",
          "SV": "dd/MM/yyyy",
          "UY": "dd/MM/yyyy",
          "VE": "dd/MM/yyyy",
          "EE": "d.MM.yyyy",
          "IR": "MM/dd/yyyy",
          "FI": "d.M.yyyy",
          "FO": "dd-MM-yyyy",
          "BE": "d/MM/yyyy",
          "MC": "dd/MM/yyyy",
          "NL": "d-M-yyyy",
          "NG": "d/M/yyyy",
          "IL": "dd/MM/yyyy",
          "HR": "d.M.yyyy",
          "HU": "yyyy. MM. dd.",
          "AM": "dd.MM.yyyy",
          "ID": "dd/MM/yyyy",
          "IS": "d.M.yyyy",
          "IT": "dd/MM/yyyy",
          "JP": "yyyy/MM/dd",
          "GE": "dd.MM.yyyy",
          "KZ": "dd.MM.yyyy",
          "GL": "dd-MM-yyyy",
          "KH": "yyyy-MM-dd",
          "KR": "yyyy-MM-dd",
          "IN": "dd-MM-yyyy",
          "KG": "dd.MM.yy",
          "LA": "dd/MM/yyyy",
          "LT": "yyyy.MM.dd",
          "LV": "yyyy.MM.dd.",
          "MK": "dd.MM.yyyy",
          "MN": "yy.MM.dd",
          "BN": "dd/MM/yyyy",
          "MT": "dd/MM/yyyy",
          "NO": "dd.MM.yyyy",
          "NP": "M/d/yyyy",
          "PL": "yyyy-MM-dd",
          "AF": "dd/MM/yy",
          "BR": "d/M/yyyy",
          "PT": "dd-MM-yyyy",
          "RO": "dd.MM.yyyy",
          "RW": "M/d/yyyy",
          "RU": "MM.dd.yyyy",
          "SE": "yyyy-MM-dd",
          "LK": "yyyy-MM-dd",
          "SK": "d. M. yyyy",
          "SI": "d.M.yyyy",
          "AL": "yyyy-MM-dd",
          "CS": "d.M.yyyy",
          "ME": "d.M.yyyy",
          "RS": "d.M.yyyy",
          "KE": "M/d/yyyy",
          "SY": "dd/MM/yyyy",
          "TJ": "dd.MM.yy",
          "TH": "d/M/yyyy",
          "TM": "dd.MM.yy",
          "TR": "dd.MM.yyyy",
          "UA": "dd.MM.yyyy",
          "PK": "dd/MM/yyyy",
          "UZ": "dd.MM.yyyy",
          "VN": "dd/MM/yyyy",
          "SN": "dd/MM/yyyy",
          "HK": "d/M/yyyy",
          "MO": "d/M/yyyy",
          "SG": "d/M/yyyy",
          "TW": "yyyy/M/d",
        };

        return formats[this.dateLocale];
      },
      formatDate(date, currentFormat) {
        if (!date || !currentFormat) return null;
        const dateObject = parse(date, currentFormat, new Date());
        return format(dateObject, this.getFormatByLocale() || "dd/MM/yyyy");
      },
      formatSQLTimestamp(timestamp) {
        if (!timestamp) return null;
        const formattedDate = this.transformSQLTimestamp(timestamp);
        if (formattedDate !== null){
          return this.formatDate(formattedDate, this.isoStandardFormat)
        }
        console.log('using raw date data')
        return timestamp
      },
    },
  }
</script>
